// const helper = require('../helper');

/**
*
* Singleton Class so you could persist the data in this class even
* it's instantiated several times in different part of the program
*/
class ServicePrices {
	constructor() {
		if (!ServicePrices.instance) {
			this.arrServicesAndPrices = [];
			ServicePrices.instance = this;
		}

		return ServicePrices.instance;
	}

	setServices(arrServicesAndPrices) {
		this.arrServicesAndPrices = arrServicesAndPrices;
	}

	get allServices() {
		return this.arrServicesAndPrices;
	}

	get groupById() {
		return this.objectsGroupBy(this.arrServicesAndPrices, 'service_setting_id');
	}

	objectsGroupBy(arr, byField) {
        if (typeof arr === 'undefined') return [];
        return arr.reduce((r, a) => {
            r[a[byField]] = [...r[a[byField]] || [], a];
            return r;
        }, {})
    }
}

module.exports = ServicePrices;